// Code Generated by Sidekick is for learning and experimentation purposes only.
import React from "react";
import { Spin, Flex } from "antd";
import WDAdvantageLogo from "../../../assets/WDAdvantageLoading.gif";

const Loader = () => {
	return (
		<Flex
			justify="center"
			align="center"
			style={{
				height: "100vh",
				width: "100vw",
				position: "fixed",
				top: 0,
				left: 0,
				background: "rgba(255,255,255,0.7)",
				zIndex: 9999,
			}}
			data-testid="loader-container"
		>
			<Spin
				size="small"
				spinning={true}
				indicator={
					<img
						src={WDAdvantageLogo}
						alt="Loading..."
						style={{ width: "10vw", height: "10vh" }}
						data-testid="loader-image"
					/>
				}
			/>
		</Flex>
	);
};

export default Loader;
